import moment from 'moment';
import React from 'react';
import FontAwesome from 'react-fontawesome';

// TODO: Use internationalization here to format time instead of moment
const Time = ({ event }) => (
  <p>
    {event.startTime ? <span><FontAwesome name="clock-o" /> {moment(event.startTime, 'hh:mm:ss').format('h:mma')}</span> : null}
    {event.startTime && event.endTime ? ' - ' : null}
    {event.endTime ? <span><FontAwesome name="clock-o" /> {moment(event.endTime, 'hh:mm:ss').format('h:mma')}</span> : null}
  </p>
);

export default Time;
